<template>
  <b-card class="no-border">
  </b-card>
</template>

<script>
  export default {
    created() {
      this.$store.commit('SET_BREADCRUMB_ITEMS', [
        { to: '', name: 'Home' },
        { to: 'vehicle', name: 'Vehicles' },
      ]);

      this.$store.commit('vehicles/CLEAR_QUERY');
      this.$store.dispatch('vehicles/LOAD_INFO');
      this.$store.dispatch('vehicles/LOAD_DATA');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pages/vehicle/Index.vue